import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ChatFileTypes } from './chatFileTypes';

export function useChatFileTypes() {
  const { flagEnabledSiestaChats } = useFlags();
  return useQuery<ChatFileTypes>({
    queryKey: ['chat', 'file-types'],
    // Backend returns 404 on this route when Siesta chats are off, so don't request it then.
    // Strict === true keeps the query disabled while LaunchDarkly is still loading and the flag
    // is undefined, which React Query would otherwise treat as enabled and fire a 404.
    enabled: flagEnabledSiestaChats === true,
    staleTime: Infinity,
  });
}
